// extracted by mini-css-extract-plugin
module.exports = {"simpleLoader":"loaders_simpleLoader__YHLAr","loader":"loaders_loader__wvx3u","loaderc":"loaders_loaderc__gH_A7","rotation":"loaders_rotation__Texb1"};